<template>
    <div>
        <button class="btn btn-white" type="button"  v-click-outside="hide" @click="open" >
            <img  :src="share" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
        </button>

        <div  id="mediaLinks" class="container bg-white media-container" v-show="opened">


            <p class="subtitle pt-3" style="font-size: 0.6em"><b>Share now...</b>
                <button @click="hide" class="w3-button cross btn-white">&times;</button></p>

            <div class="row">
                <div class="col">
                    <a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+  getURL()">
                        <img  :src="facebook" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
                        <p class="subtitle">Facebook</p>
                    </a>
                </div>
                <div class="col">
                    <a v-bind:href="'https://www.messenger.com/login/'">
                        <img  :src="messenger" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
                        <p class="subtitle">Messenger</p>
                    </a>
                </div>
                <div class="col">
                    <a v-bind:href="'https://twitter.com/share?url='+  getURL()+'&text='+text">
                        <img  :src="twitter" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
                        <p class="subtitle">Twitter</p>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <a v-bind:href="'mailto:?&subject=&body='+text+  getURL()">
                        <img  :src="email" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
                        <p class="subtitle">Email</p>
                    </a>
                </div>
                <div class="col">
                    <a v-bind:href="'https://wa.me/?text='+text+  getURL()">
                        <img  :src="whatsapp" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
                        <p class="subtitle">Whatsapp</p>
                    </a>
                </div>
                <div class="col">
                    <a class="btn-white" @click="copyToClipboard">
                        <img  :src="clipboard" class="img-fluid" alt="share" style="height: 1.5em; margin-left: 0.5em">
                        <p class="copy-clipboard">Copy to Clipboard</p>
                    </a>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
    name: "MediaShare",
    props: {
        "clipboard": String,
        "facebook":String,
        "twitter":String,
        "email":String,
        "messenger":String,
        "whatsapp":String,
        "share":String,
        "url":String,
        "text":{
            String,
            default: "Check us out at Leafythings! "
        },
    },
    data () {
        return {
            opened: false
        }
    },

    methods: {
        copyToClipboard() {

            var $temp = $("<input>");
            $("body").append($temp);

            $temp.val(window.location.href).select();
            document.execCommand("copy");
            $temp.remove();
            alert("URL added to clipboard");
        },
        open () {
            if(!this.opened) {
                this.opened = true
            }
            else
            {
                this.opened=false
            }
        },

        hide () {
            this.opened = false
        },

        getURL()
        {
            return window.location.href;
        }

    },
    mounted () {
        this.popupItem = this.$el

    },

    directives: {
        ClickOutside
    }
};
</script>

<style scoped lang="scss">
.cross{
    color: black;
    position: absolute;
    right:20px;
    top:10px;
    font-size: 16px;
    font-weight: bold;
}
.media-container{
    position:absolute;
    z-index: 9;
    border: 3px solid lightgray;
    border-radius: 0.5em;
    width: 9em;
}
.subtitle, .copy-clipboard {
    color: black;
    vertical-align: top;
    text-align:center;
    font-weight: 400;
    font-size: 0.4em;
}
.btn-white{
    background-color: white;
    border: white;
    outline: none;
}
.copy-clipboard:hover, .btn-white:hover{
    cursor: pointer;
}
a:hover{
    text-decoration: none;
}
</style>
